import { createHook, createStore, createActionsHook } from 'react-sweet-state';

const initialState = {
	isHelpCenterOpen: false,
	isHelpCenterManuallyOpened: false,
	shouldShowHelpMenuSpotlight: null,
	isFeatureDiscovered: false,
};

export const actions = {
	openHelpCenter:
		(isHelpCenterManuallyOpened: boolean = false) =>
		({ setState }) => {
			setState({ isHelpCenterOpen: true, isHelpCenterManuallyOpened });
		},
	closeHelpCenter:
		() =>
		({ setState }) => {
			setState({ isHelpCenterOpen: false, isHelpCenterManuallyOpened: false });
		},
	showHelpMenuSpotlight:
		() =>
		({ setState }) => {
			setState({ shouldShowHelpMenuSpotlight: true });
		},
	hideHelpMenuSpotlight:
		() =>
		({ setState }) => {
			setState({ shouldShowHelpMenuSpotlight: false });
		},
	setFeatureDiscovered:
		(discoveryState: boolean) =>
		({ setState }) => {
			setState({ isFeatureDiscovered: discoveryState });
		},
};

const store = createStore({
	initialState,
	actions,
});

export const useHelpMenuState = createHook(store);
export const useHelpMenuActions = createActionsHook(store);
